var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgVideoStep4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 46.999,
    viewBox: "0 0 37 46.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11426",
    "data-name": "Group 11426",
    transform: "translate(-776.244 -8609.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11425",
    "data-name": "Group 11425",
    transform: "translate(779.744 8613)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37165",
    "data-name": "Path 37165",
    d: "M.03,20q0-7.879,0-15.758A3.908,3.908,0,0,1,4.318.019c7.119,0,14.238.03,21.357-.019A4.127,4.127,0,0,1,30,4.308q-.1,15.684,0,31.369A4.144,4.144,0,0,1,25.611,40q-10.6-.084-21.209,0A4.147,4.147,0,0,1,0,35.613C.1,30.411.03,25.206.03,20m2.576-3.893q0,5.9,0,11.8c0,1.294.427,1.725,1.714,1.725q10.679,0,21.359,0c1.289,0,1.718-.431,1.718-1.722q0-11.764,0-23.529c0-1.334-.432-1.77-1.752-1.77H4.36c-1.325,0-1.753.431-1.754,1.766q0,5.864,0,11.728M14.991,32.864c-.419,0-.838-.015-1.256,0a1.975,1.975,0,0,0-1.984,1.952,1.955,1.955,0,0,0,1.932,1.925c.885.038,1.775.04,2.66,0A1.949,1.949,0,0,0,18.252,34.8a1.97,1.97,0,0,0-1.932-1.929c-.442-.025-.886,0-1.33,0",
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#7833ba",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37166",
    "data-name": "Path 37166",
    d: "M54.848,73.47a2.58,2.58,0,0,0-2.82-2.864c-2.305-.007-4.611,0-6.916,0s-4.611-.005-6.916,0a2.572,2.572,0,0,0-2.8,2.814q-.006,3.053,0,6.107a2.614,2.614,0,0,0,2.783,2.857q6.953.019,13.906,0a2.606,2.606,0,0,0,2.759-2.806q.008-3.053,0-6.107M40.376,77.6h-1.23v1.658c0,.317-.2.5-.588.5s-.587-.183-.587-.5V74.481a.6.6,0,0,1,.666-.674h1.739a1.9,1.9,0,1,1,0,3.792m7.042,2.094a.562.562,0,0,1-.768-.238l-.439-1.182H43.886l-.439,1.182a.554.554,0,0,1-.768.246.49.49,0,0,1-.3-.7l1.974-4.91a.789.789,0,0,1,1.379,0L47.708,79a.5.5,0,0,1-.29.69m5.107-5.085-1.974,2.673v1.975c0,.317-.211.5-.6.5s-.6-.183-.6-.5V77.282l-1.966-2.673a.552.552,0,0,1,.164-.785.58.58,0,0,1,.854.135l1.543,2.174,1.574-2.205a.553.553,0,0,1,.815-.111.542.542,0,0,1,.18.793",
    transform: "translate(-30.123 -60.32)",
    fill: "#fff",
    stroke: "#7833ba",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37167",
    "data-name": "Path 37167",
    d: "M62.053,98.5H60.895v1.888h1.158c.508,0,.833-.325.833-.944s-.325-.944-.833-.944",
    transform: "translate(-51.903 -84.074)",
    fill: "#fff",
    stroke: "#7833ba",
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11424",
    "data-name": "Group 11424",
    transform: "translate(779.744 8613.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37165-2",
    "data-name": "Path 37165",
    d: "M.03,20q0-7.879,0-15.758A3.908,3.908,0,0,1,4.318.019c7.119,0,14.238.03,21.357-.019A4.127,4.127,0,0,1,30,4.308q-.1,15.684,0,31.369A4.144,4.144,0,0,1,25.611,40q-10.6-.084-21.209,0A4.147,4.147,0,0,1,0,35.613C.1,30.411.03,25.206.03,20m2.576-3.893q0,5.9,0,11.8c0,1.294.427,1.725,1.714,1.725q10.679,0,21.359,0c1.289,0,1.718-.431,1.718-1.722q0-11.764,0-23.529c0-1.334-.432-1.77-1.752-1.77H4.36c-1.325,0-1.753.431-1.754,1.766q0,5.864,0,11.728M14.991,32.864c-.419,0-.838-.015-1.256,0a1.975,1.975,0,0,0-1.984,1.952,1.955,1.955,0,0,0,1.932,1.925c.885.038,1.775.04,2.66,0A1.949,1.949,0,0,0,18.252,34.8a1.97,1.97,0,0,0-1.932-1.929c-.442-.025-.886,0-1.33,0",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37166-2",
    "data-name": "Path 37166",
    d: "M54.848,73.47a2.58,2.58,0,0,0-2.82-2.864c-2.305-.007-4.611,0-6.916,0s-4.611-.005-6.916,0a2.572,2.572,0,0,0-2.8,2.814q-.006,3.053,0,6.107a2.614,2.614,0,0,0,2.783,2.857q6.953.019,13.906,0a2.606,2.606,0,0,0,2.759-2.806q.008-3.053,0-6.107M40.376,77.6h-1.23v1.658c0,.317-.2.5-.588.5s-.587-.183-.587-.5V74.481a.6.6,0,0,1,.666-.674h1.739a1.9,1.9,0,1,1,0,3.792m7.042,2.094a.562.562,0,0,1-.768-.238l-.439-1.182H43.886l-.439,1.182a.554.554,0,0,1-.768.246.49.49,0,0,1-.3-.7l1.974-4.91a.789.789,0,0,1,1.379,0L47.708,79a.5.5,0,0,1-.29.69m5.107-5.085-1.974,2.673v1.975c0,.317-.211.5-.6.5s-.6-.183-.6-.5V77.282l-1.966-2.673a.552.552,0,0,1,.164-.785.58.58,0,0,1,.854.135l1.543,2.174,1.574-2.205a.553.553,0,0,1,.815-.111.542.542,0,0,1,.18.793",
    transform: "translate(-30.123 -60.319)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37167-2",
    "data-name": "Path 37167",
    d: "M62.053,98.5H60.895v1.888h1.158c.508,0,.833-.325.833-.944s-.325-.944-.833-.944",
    transform: "translate(-51.903 -84.074)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37168",
    "data-name": "Path 37168",
    d: "M95.508,103.2h1.642l-.825-2.189Z",
    transform: "translate(-81.404 -86.212)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9013",
    "data-name": "Rectangle 9013",
    width: 30,
    height: 39.999,
    transform: "translate(0)",
    fill: "none"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgVideoStep4);
export default __webpack_public_path__ + "static/media/img_video_step_4.c7a958e183aac3ead78dd49a9a30b596.svg";
export { ForwardRef as ReactComponent };